import { RouteType } from '@/lib/route';
import QuizQuestionsComponent from '.';

const QuizQuestionsRoutes: RouteType = {
  path: '/module/:elearningId/quiz/:questionId',
  component: QuizQuestionsComponent,
};

export interface QuestionParamType {
  elearningId: string;
  questionId: string;
}

export default QuizQuestionsRoutes;
